var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 50,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2BABE2",
    d: "M0 25v25c14.554 0 26.354-11.194 26.354-25V0C11.8 0 0 11.194 0 25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE300",
    d: "M52.738 25v25c14.555 0 26.355-11.194 26.355-25V0C64.538 0 52.738 11.194 52.738 25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#66C3A2",
    d: "M52.708 25c0-13.806-11.775-25-26.354-25v25c0 13.806 11.8 25 26.354 25z"
  })));
};
export { SvgLogo as ReactComponent };
export default __webpack_public_path__ + "37fc13547c686293a44e9e7c1a50be3a.svg";